import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { DeleteButton } from 'sos-eservice-common/js/components/General/DeleteButton';

export interface IDeleteAnsokanProps {}
export interface IDeleteAnsokanState extends FormSectionBaseState {}

export default class DeleteAnsokan extends FormSectionBase<IDeleteAnsokanProps, IDeleteAnsokanState> {
  constructor(props: IDeleteAnsokanProps) {
    super(props);

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  public render() {
    const { isInEditMode, Translate, myPageLink, ansokanId } = this.context;
    return (
      <div className="delete-order">
        <DeleteButton
          postLink={`${myPageLink}DeleteIntyg?id=${ansokanId}`}
          disabled={isInEditMode}
          actionText={Translate('/deleteModal/delete')}
          cancelText={Translate('/deleteModal/cancel')}
          modalHeading={Translate('/deleteModal/heading')}
          modalBody={Translate('/deleteModal/text')}
        />
      </div>
    );
  }
}
